import { Alert, LinearProgress } from '@mui/joy';

import { useParams } from 'react-router-dom';

import Breadcrumbs from '@/components/Breadcrumbs';
import { useRun } from '@/hooks/useSwr';

import Header from '../../components/CodeHeader';
import { RunsPlayground } from '../Playground/RunsPlayground';

export function PublicRunPlayground() {
  const { shareToken, runId } = useParams();

  const publicRun = useRun({
    id: runId,
    shareToken: { runShareToken: shareToken },
    withContents: true,
  });

  const run = publicRun.data;
  return (
    <div className="flex h-screen flex-col">
      <div className="px-4 pt-3">
        <Breadcrumbs />
        {publicRun.isLoading && <LinearProgress />}
        {publicRun.error && (
          <>
            <Header text="Error" copy={publicRun.error?.message} />
            <Alert color="danger" variant="outlined" sx={{ marginBottom: 3 }}>
              {publicRun.error?.message}
            </Alert>
          </>
        )}
      </div>
      {run && <RunsPlayground run={run} />}
    </div>
  );
}
